import { OrderStatus } from '~/types/order';

// OrderType.PLATFORM_PICKUP_POINT
export const platformPickupPointMapString = {
  [OrderStatus.DISTRIBUTED]: '等待店家接受中',
  [OrderStatus.CREATED]: '店家已接受預約',
  [OrderStatus.ACCEPTED]: '餐點準備中',
  [OrderStatus.PICKED]: '司機已取餐',
  [OrderStatus.DELIVERED]: '餐點已送達',
  [OrderStatus.COMPLETED]: '消費者已取餐',
};
